module.exports = __webpack_public_path__ + "img/高抒霞@2x.774b3938.png";